export var PageName = function (PageName) {
  PageName["HOME"] = "home";
  PageName["SRP"] = "SRP";
  PageName["HDP"] = "HDP";
  PageName["CYB"] = "CYB";
  PageName["CYT"] = "CYT";
  PageName["DLP"] = "DLP";
  PageName["ANCILLARIES"] = "ancillaries";
  PageName["GUEST_DETAILS"] = "gdp";
  PageName["PAYMENT"] = "payment";
  PageName["CONFIRMATION"] = "confirmation";
  PageName["AMEND"] = "amend";
  PageName["DASHBOARD"] = "dashboard";
  PageName["REGISTER"] = "register";
  PageName["GROUP_BOOKINGS"] = "groupBookings";
  PageName["PRICE_FINDER"] = "priceFinder";
  PageName["STAY_DATES"] = "stayDates";
  PageName["ROOMS_AND_GUESTS"] = "roomsAndGuests";
  PageName["ADD_TO_WALLET"] = "addToWallet";
  return PageName;
}({});